<div class="table-padding">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef> Select </th>
            <td mat-cell *matCellDef="let element">
                <div class="checkbox-color" [ngClass]="{'disabled-cursor': mode === 'read'}"
                    [id]="tourGuideIds.configBuilder.workflow.toolsThreshHoldTab.checkBox.id">
                    <mat-checkbox class="example-margin" [disabled]="mode==='read'" [(ngModel)]="element.checkbox"
                        (change)="addQualityGates(element)"></mat-checkbox>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="tool">
            <th mat-header-cell *matHeaderCellDef> Tool</th>
            <td mat-cell *matCellDef="let element" class="width-90"> {{element?.tool}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Quality gates </th>
            <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
        </ng-container>
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> Description</th>
            <td mat-cell *matCellDef="let element">
                <div class="desc"> {{element.desc}}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="condition">
            <th mat-header-cell *matHeaderCellDef> Condition </th>
            <td mat-cell *matCellDef="let element">
                <mat-select #select [id]="tourGuideIds.configBuilder.workflow.toolsThreshHoldTab.condition.id"
                    [ngClass]="{'disabled-cursor': mode === 'read'}" [(ngModel)]="element.operator"
                    class="dropdown-cond" (selectionChange)="addQualityGates(element)" placeholder="select condition"
                    [disabled]="!element.checkbox || mode === 'read'">
                    <mat-option *ngFor="let op of operatorList" [value]="op">{{op}}</mat-option>
                </mat-select>
            </td>
        </ng-container>

        <ng-container matColumnDef="threshold">
            <th mat-header-cell *matHeaderCellDef> Threshold </th>
            <td mat-cell *matCellDef="let element">
                <div class="threshold-input-box">
                    <input matInput type="number" [ngClass]="{'disabled-cursor': mode === 'read'}" class="width-70"
                        [id]="tourGuideIds.configBuilder.workflow.toolsThreshHoldTab.inputBox.id"
                        (input)="addQualityGates(element, $event)" [disabled]="!element.checkbox || mode === 'read'"
                        [(ngModel)]="element.threshold"
                        [ngStyle]="{'background-color': element.checkbox ? 'white' : '', 'border' : element.checkbox ? '1px solid gray' : ''}"
                        min="0" max="9999" />
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="failure">
            <th mat-header-cell *matHeaderCellDef> Allow failure </th>
            <td mat-cell *matCellDef="let element">
                <div class="slide-toggle-class">
                    <mat-slide-toggle [id]="tourGuideIds.configBuilder.workflow.toolsThreshHoldTab.allFail.id"
                        [ngClass]="{'disabled-cursor': mode === 'read'}" [(ngModel)]="element.alwFail" [checked]="true"
                        (change)="addQualityGates(element)"
                        [disabled]="!element.checkbox || mode === 'read'"></mat-slide-toggle>
                </div>
            </td>
        </ng-container>

        <!--This row will get displayed where there is no data available in tools & thresholds tab's table-->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan=9>
                <div class="emptyData" fxLayout="row" fxLayoutAlign="center center">
                    <app-no-data-available [newData]="getNoData"></app-no-data-available>
                </div>
            </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>